export default __webpack_public_path__ + "static/media/not-disturb.0567b040.svg";